import { useFetchChatList } from '@modules/oracle/hooks';
import {
  Box,
  CircularProgress,
  List,
  Stack,
  Typography,
  alpha,
} from '@mui/material';
import { useEffect } from 'react';
import { WisdomChatListEmptyState } from '../WisdomChatListEmptyState';
import { WisdomSavedChatListItem } from '../WisdomSavedChatListItem';
import { WisdomSeeAllChatsButton } from '../WisdomSeeAllChatsButton';

export const WisdomSavedChatList = () => {
  const [fetchChatList, { isLoading, chatList, chatListWithRelativeTime }] =
    useFetchChatList();

  useEffect(() => {
    fetchChatList();
  }, [fetchChatList]);

  if (isLoading) {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (chatList.length === 0) {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <WisdomChatListEmptyState />
      </Stack>
    );
  }

  return (
    <Stack mt={4}>
      <Stack direction="row" alignItems="baseline" spacing={0.5}>
        <Typography variant="body1" color="text.secondary">
          Recent chats
        </Typography>
        <Typography variant="caption" color="text.disabled">
          (Private to you)
        </Typography>
      </Stack>
      <Box overflow="hidden">
        {Object.entries(chatListWithRelativeTime).map(
          ([relativeTime, chats]) => (
            <Stack key={relativeTime} mt={2}>
              <Typography variant="body2" color="text.secondary">
                {relativeTime}
              </Typography>
              <List>
                {chats.map((chat) => (
                  <WisdomSavedChatListItem key={chat.id} chat={chat} />
                ))}
              </List>
            </Stack>
          ),
        )}
      </Box>
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          zIndex: (theme) => theme.zIndex.drawer,
          backgroundColor: (theme) => theme.palette.misc?.drawer.background,
          pb: 2.5,
          mt: 1.6,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '20px',
            boxShadow: (theme) =>
              `0 0 10px 20px ${alpha(
                theme.palette.misc?.drawer.background ??
                  theme.palette.background.default,
                0.9,
              )}`,
          },
        }}
      >
        <WisdomSeeAllChatsButton />
      </Box>
    </Stack>
  );
};
